import { render, staticRenderFns } from "./wodlicai.vue?vue&type=template&id=4ab66b30&scoped=true"
import script from "./wodlicai.vue?vue&type=script&lang=js"
export * from "./wodlicai.vue?vue&type=script&lang=js"
import style0 from "./wodlicai.vue?vue&type=style&index=0&id=4ab66b30&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ab66b30",
  null
  
)

export default component.exports